import { ActionReducer, createReducer, MetaReducer, on } from '@ngrx/store';
import { BatchActions } from './batch.actions';
import { produce } from 'immer';
import { Keys, localStorageSync } from 'ngrx-store-localstorage';
import {
  rsLocalStorageMergeReducer
} from '@rs-shared-lib/3rd-party-libraries/ngrx-store-localstorage/rs-local-storage-merge-reducer';
import { QueryParamsBatch } from '@batch/shared/models/batch';

export const batchFeatureKey = 'ordAdminBatch';

export interface BatchState {
  tablePagination: QueryParamsBatch;
}

export const batchFilterInitialState: BatchState = {
  tablePagination: {
    _page: 1,
    _pageSize: 10
  }
};

export const batchReducer = createReducer(
  batchFilterInitialState,
  on(BatchActions.updateTablePaginator, (state, { tablePagination }) =>
    produce(state, (draft: BatchState) => {
      Object.assign(draft.tablePagination, tablePagination);
    }))
);

export function localStorageSyncReducer(reducer: ActionReducer<BatchState>): ActionReducer<BatchState> {
  return localStorageSync({
    keys: ['tablePagination'] as Keys,
    storageKeySerializer: key => 'ord_persistent_' + key,
    rehydrate: true,
    mergeReducer: rsLocalStorageMergeReducer
  })(reducer);
}

export const batchMetaReducers: Array<MetaReducer<BatchState>> = [localStorageSyncReducer];

